import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PortalAccess } from '../../models/portal-access';

@Injectable()
export class PortalAccessService {
  constructor(private readonly httpClient: HttpClient) { }

  public get(): Observable<PortalAccess> {
    return this.httpClient.get<PortalAccess>(`${environment.apiBaseUrl}portal-access`);
  }
}
